import api from './api'

/**
 * Verificar si el sistema está listo para recibir login
 * @returns {Promise<{ready: boolean, mode: string, message: string}>}
 */
export async function checkSystemReady() {
  const response = await api.get('/system/ready')
  return response.data
}

